module.exports = __webpack_public_path__ + "static/img/dani.3065443.jpg";